import type { Nullable, User } from "@msuite/utils/types";
import { createContext, useContext } from "react";

/** Interface */
interface IAuthContext {
	user: Nullable<User>;
}

export const AuthContext = createContext<IAuthContext>({} as IAuthContext);

export function useAuthContext() {
	return useContext(AuthContext);
}
